
import { Component, Vue } from "vue-property-decorator";
import router, { asyncRouter } from "./router/index";
import { log } from "util";



@Component({
  name: "App"
})
export default class extends Vue {
  signedIn: boolean = true;

  beforeCreate() {

  }
}
